goog.provide('el8.appchart.dialog.displayItem');

// goog.require('el8.appchart.reportFeeds.contentRenderer'); - circular dependency
// goog.require('el8.appchart.showItemDetail'); - circular dependency
goog.require('el8.data.educationalHandouts');
goog.require('el8.model.identify');
goog.require('el8.ptdata.fetch');
goog.require('el8.ptdata.model.note.asSoyMap');
goog.require('el8.service.tz');
goog.require('el8.shared.commentReplyForm');
goog.require('el8.template.appchart.dialog.displayItem');
goog.require('el8.template.render.chartFeedItem');
goog.require('el8.template.render.medsHx');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.util.feed');

el8.appchart.dialog.displayItem = (function() {

    var that = new el8.uiwidget.NewDialog({
        title: 'Displaying Item Detail',
        autoHeight: true,
        width: 570,
        position: 'center',
        showXButton: true
    });

    function getContent(item) {
        // TODO: NewChartFeed: refactor with chartRenderer?
        var _templateBase = el8.template.render.chartFeedItemNew;

        if (el8.model.identify.isReport(item) && item.isDeleted()) {
            var reportRenderer = el8.appchart.reportFeeds.contentRenderer(item, false); // no actions
            var $result = reportRenderer(item).children(':first');
            // Remove all the input areas from the report note, namely ability to add
            // addendums and ability to add note items (if report is unsigned)
            // Note that this means that in the case of the report being unsigned, we DON'T
            // show any note items.
            $('.report-notes-input', $result).remove();
            return $result;

        } else if (el8.model.identify.isOrder(item) && item.isDeleted()) {
            var $result = $(el8.template.appchart.dialog.displayItem.deletedOrder({
                documentDate: el8.service.tz.soyStr(item.getDocumentDate())
            }));
            var orderRenderer = el8.appchart.reportFeeds.contentRenderer(item);
            $result.append(orderRenderer(item).children(':first'));
            return $result;

        } else if (item.is('MedOrder')) {
            var map = item.asSoyMap();
            if (item.getFulfillmentMgr().getLatestPharmacy()) {
                map['pharmacy'] = item.getFulfillmentMgr().getLatestPharmacy().asSoyMap();
            }
            return $(el8.template.render.medsHx.orderDetails({order: map}));

        } else if (item.is('NonvisitNote')) {
            var $div = $(el8.template.appchart.dialog.displayItem.defaultContainer());
            var $nonvisitContents = null;

            var map = el8.ptdata.model.note.asSoyMap(item);
            map['buttonsInfo'] = [];
            map['signUserId'] = item.getSignUserId();
            map['currUserId'] = el8.data.currUser.getId();

            var _nvnContents = _templateBase.nonvisitNote(map);

            $nonvisitContents = $(_nvnContents).find('.el8FeedItemColMain').contents();

            $div.append($nonvisitContents);
            $('.el8FeedItemColActions', $div).remove();
            return $div;

        } else if (item.is('VisitNote')) {
            var map = el8.ptdata.model.note.asSoyMap(item);
            map['buttonsInfo'] = [];
            map['isAmendPreview'] = false;
            map['showMuInfo'] = el8Globals['FEATURES']['MUReports'];
            map['feedItemId'] = item.getFeedItemId();

            var $result = $(_templateBase.visitNote(map));

            $result = $result.find('.el8FeedItemColMain');
            $('.el8FeedItemColActions', $result).remove();

            $result = $result.contents();

            $('.toggle-summary-trigger', $result).remove();
            $('.addToNoteHpiTrigger', $result).remove();
            $('.visit-note-toggle-collapse-status', $result).remove();

            $('.el8ItemHover', $result).removeClass('el8ItemHover');
            if (item.getImages().length) {
                $('.visit-image-section', $result).html(
                    el8.template.render.chartFeedItem.visitNoteContent.imageList({
                        id: item.getId(),
                        images: item.getImages()
                    })
                );
            }

            var $div = $(el8.template.appchart.dialog.displayItem.defaultContainer());
            $div.append($result);
            return $div;

        } else if (item.is('Letter')) {
            var $letterContents = null;
            var $div = $(el8.template.appchart.dialog.displayItem.defaultContainer());
            var _letterContents = _templateBase.letterItem({
                feedDate: el8.service.tz.soyStr(item.getChartFeedDate()),
                buttonsInfo: [],
                patient: el8.ptdata.currPatient.asSoyMap(),
                letter: item.asSoyMap(),
                currUserId: el8.data.currUser.getId()
            });

            // We don't want the letter icon / date wasting space on the left side, so we grab its inner contents
            $letterContents = $(_letterContents).find('.el8FeedItemColMain').contents();

            $div.append($letterContents);

            $('.el8FeedItemColActions', $div).remove();
            $('.letter-toggle-collapse-trigger', $div).remove();
            $('.floating-link-list', $div).remove();
            $('.feed-button-list', $div).remove();

            var letterId = item.getId();
            $div.on('click', '.comment-reply-trigger',  function() {
                el8.shared.commentReplyForm.show({
                    container: $div,
                    docId: letterId
                });
                that.adjustHeight();

            }).on('click', '.reopen-comments-trigger',  function() {
                el8.ptdata.letters.getById(letterId).reopenThread(function(letter) {
                    el8.appservice.notifier.notify('Passport response thread reopened');
                    $('.letter-comments', $div).replaceWith(
                        el8.template.ptdata.letters.commentSection(letter.asSoyMap())
                    );
                });
                that.adjustHeight();

            }).on('click', '.close-letter-comments-trigger',  function() {
                item.closeThread(function(letter) {
                    el8.appservice.notifier.notify('Passport response thread closed');
                    $('.letter-comments', $div).replaceWith(
                        el8.template.ptdata.letters.commentSection(letter.asSoyMap())
                    );
                });
                that.adjustHeight();

            });

            return $div;

        } else if (item.is('LetterReceipt')) {
            var $div = $(el8.template.appchart.dialog.displayItem.defaultContainer());
            var $contents = $(_templateBase.letterReceipt({
                feedDate: el8.service.tz.soyStr(item.getChartFeedDate()),
                buttonsInfo: [],
                patient: el8.ptdata.currPatient.asSoyMap(),
                letterReceipt: item.asSoyMap(),
                currUserId: el8.data.currUser.getId()
            }));

            // We don't want the letter icon / date wasting space on the left side, so we grab its inner contents
            $contents = $contents.find('.el8FeedItemColMain').contents();
            $div.append($contents);

            $('.el8FeedItemColActions', $div).remove();
            $('.item-details-trigger', $div).remove();
            $('.letter-body-preview', $div).remove();
            $('.letter-toggle-collapse-status', $div).remove();

            $('.letter-body', $div).removeClass('el8SingleLineText').addClass('el8Preserve');

            $div.on('click', '.comment-reply-trigger',  function() {
                el8.shared.commentReplyForm.show({
                    container: $div,
                    docId: item.getId()
                });
                that.adjustHeight();

            }).on('click', '.view-inline-pdf',  function(e) {
                el8.app.shared.dialog.viewInlinePdf.show({
                    docFileId: e.target.dataset.id*1
                });

            }).on('click', '.file-receipt-report',  function(e) {
                var attachmentId = e.target.dataset.id*1;
                item.fileReport(attachmentId, function(updated) {
                    $('.attachment-section', $div).replaceWith(
                        el8.template.ptdata.letterReceipts.attachmentSection(updated.asSoyMap())
                    );
                });
            });

            return $div;

        } else if (item.is('MessageThread')) {
            var $threadContents = null;
            var map = item.asSoyMap(true);
            map['buttonsInfo'] = [];
            map['feedItemId'] = item.getFeedItemId();
            map['feedDate'] = el8.service.tz.soyStr(item.getChartFeedDate());

            var _contents = _templateBase.messageThread(map);
            $threadContents = $(_contents).find('.el8FeedItemColMain').contents();

            var $div = $(el8.template.appchart.dialog.displayItem.defaultContainer());
            $div.append($threadContents);
            $('.el8FeedItemColActions', $div).remove();
            return $div;
        }

        return '';
    }

    function setWidthLoadImages(item) {
        var loadImages = function() {
            el8.util.feed.loadImages({
                item: item,
                images: item.getImages(),
                container: that.getContentElt(),
                width: 800
            });
        };
        if (el8.model.identify.isReport(item) && item.isDeleted() && item.getImages().length) {
            that.setWidth(570);
            el8.appchart.reportFeeds.expandFn(item, that.getContentElt());
            item.setImagesLoaded(false); // we'll want to display the images again every time

        } else if (item.is('NonvisitNote') || item.is('VisitNote')) {
            if (item.getImages().length) {
                that.setWidth(800);
                loadImages();
            } else if (item.is('VisitNote')) {
                that.setWidth(800);
            } else { // for NonvisitNote
                that.setWidth(570);
            }

        } else if (item.is('Letter')) {
            that.setWidth(800);

        } else {
            that.setWidth(570);
        }
    }

    function bindTriggers(item) {
        if (item.is('VisitNote') || item.is('NonvisitNote') || item.is('Letter') || item.is('LetterReceipt')) {
            var openItemFn = function(id) {
                if (el8.model.idToModelClass(id) === 'Handout') {
                    el8.data.educationalHandouts.downloadById(id);
                } else {
                    el8.appchart.showItemDetail(id);
                }
                return false;
            };
            that.getContentElt().on('click', '.item-details-trigger',  function() {
                var id = $(this).attr('data-id')*1;
                openItemFn(id);
            }).on('click', '.edit-changes-trigger',  function() {
                var fid = $(this).attr('_fid');
                var item = el8.ptdata.fetch(el8.util.feed.fromFeedItemId(fid));
                var editId = $(this).attr('_id') * 1;
                el8.appchart.dialog.visitNoteEdit.show(item, editId);
                return false;
            });
        }
    }

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        // make sure title doesn't overflow one line and increase the padding
        // to prevent the ellipsis from running into the X button
        that.getTitleElt().addClass('el8Ellipsis padr25');
    };

    var super_show = that.show;
    that.show = function(item, callbackFn) {
        super_show.call(that);

        var title = el8.template.appchart.dialog.displayItem.title({item: item.asSoyMap()});
        that.setTitle(title);

        that.setContent(getContent(item));
        setWidthLoadImages(item);

        bindTriggers(item);
        if (callbackFn) { callbackFn(that.getContentElt()); }
        that.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        that.getContentElt().empty(); // make sure events are unbound
    };

    return that;

})();
